import React, { useState, useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import "./AdminProfile.scss";
import moment from "moment";
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Button from "@mui/material/Button";
import { ChangeSnackbar } from "../../../Redux/Actions/SnackbarActions/SnackbarActions";
import { FetchingAdminById } from "../../../Redux/Actions/AdminActions/FetchingAdminByName";
import Box from "@mui/material/Box";
import {
  CircularProgress,
  FormControl,
  InputLabel,
  OutlinedInput,
} from "@material-ui/core";
import { useTheme } from "@mui/material/styles";
import { useNavigate } from "react-router-dom";
import { MdCancel, MdCheck, MdEdit } from "react-icons/md";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import { handleSnackbar } from "../../../helpers/SnackbarHelper/SnackbarHelper";
import {
  useAppDispatch,
  useAppSelector,
  useAppThunkDispatch,
} from "../../../Redux/hooks";
import { AdminInterFace } from "../../../Components/FeedComponents/Feed/Feed";
import { Masjid } from "../../../../Types";
import { Autocomplete } from "@mui/material";
import toast from "react-hot-toast";
import { mailChecker } from "../../../helpers/HelperFunction";
import MasjidsAutocomplete from "../../Shared/MasjidsAutocomplete/MasjidsAutocomplete";
import PageContainer from "../../Shared/PageContainer/PageContainer";
import { roleRenamer } from "../../../helpers/RoleRenamer";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;

function getStyles(name: Masjid, masjidName: any, theme: any) {
  return {
    fontWeight:
      masjidName.indexOf(name) === -1
        ? theme.typography.fontWeightRegular
        : theme.typography.fontWeightMedium,
  };
}

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const AdminProfile = () => {
  let navigate = useNavigate();
  const adminString = localStorage.getItem("admin");
  const admin: AdminInterFace = adminString ? JSON.parse(adminString) : null;
  const { adminId } = useParams();
  const dispatch = useAppThunkDispatch();
  interface AdminType {
    _id: string;
    adminName: string;
    email: string;
    name: string;
    role: string;
    isVerified: boolean;
    updatedAt: string;
    createdAt: string;
  }

  const [Admin, setAdmin] = useState<AdminType>();
  const sidebarState = useAppSelector((state) => state.sidebarState);
  //com-3
  // let AdminNameRef = useRef(Admin ? Admin.adminName : admin?.adminName);
  // let AdminEmailRef = useRef(Admin ? Admin?.email : admin?.email);
  const [role, setRole] = useState("");
  const masjids = useAppSelector((state) => state.masjids);
  const [isFetching, setisFetching] = useState(false);
  const theme = useTheme();
  const [masjidName, setMasjidName] = React.useState([]);
  const [AdminMasjid, setAdminMasjid] = useState("");
  const [NewmasjidName, setNewMasjidName] = useState("");
  const [selectedMasjidId, setId] = useState("");

  const handleChange = (event: any) => {
    setId(event?._id);
    setNewMasjidName(event?.masjidName);
  };

  useEffect(() => {
    setRole(Admin?.role);
  }, [Admin]);

  useEffect(() => {
    setisFetching(true);
    if (adminId !== undefined) {
      const response = dispatch(FetchingAdminById(adminId));
      response.then(function (result: any) {
        if (result.success) {
          setisFetching(false);
          if (
            result.data?.masjidDetails &&
            result.data.masjidDetails.length > 0
          ) {
            let masjid = masjids.filter(
              (item) => item._id === result.data.masjidDetails[0]
            );
            setAdminMasjid(masjid?.masjidName);
          }
          setAdmin(result.data);
        } else {
          const snackbarFailureDetails = {
            snackbarOpen: true,
            snackbarType: "error",
            snackbarMessage: result.message
              ? "Failed to Load Admin Details : " + result.message
              : "Failed to Load Masjid Details : Internet or Server Issue ",
          };
          setisFetching(false);
          setMasjidName([]);
          dispatch(ChangeSnackbar(snackbarFailureDetails));
        }
      });
    }
  }, [masjids, adminId]);

  return (
    <PageContainer title="Admin Profile">
      <div className="single-contain-admin-profile">
        {isFetching && (
          <>
            <span className="LoadingMessage">
              Fetching The Admin Data{" "}
              <CircularProgress
                size="20px"
                style={{ marginLeft: "10px", marginTop: "5px" }}
              />
            </span>
          </>
        )}

        <div className="top">
          <div className="admin-left">
            <div className="item">
              <div className="details">
                {Admin?._id ? (
                  <>
                    <h1 className="itemTitle">{Admin && Admin?.name}</h1>
                    <div className="detailItem">
                      <span className="itemKey">Email : </span>
                      <span className="itemValue">
                        {Admin && Admin?.email ? (
                          Admin?.email
                        ) : (
                          <span className="itemKey2">
                            {" "}
                            {"No Email available for the Admin"}
                          </span>
                        )}
                      </span>
                    </div>

                    <div className="detailItem">
                      <span className="itemKey">Role :</span>
                      <span className="itemValue">
                        {Admin && roleRenamer(Admin?.role)}
                        {/* 
                            //com-3

                          {Admin && Admin?.role : Admin?.role} */}
                      </span>
                    </div>

                    <div className="detailItem">
                      <b>
                        <span className="itemKey">Created At :</span>
                      </b>
                      <span className="itemValue">
                        {Admin ? (
                          moment(Admin?.createdAt).format("DD/MM/YYYY")
                        ) : (
                          <span className="itemKey2">
                            {" "}
                            {"Last Update is not Available"}{" "}
                          </span>
                        )}
                      </span>
                    </div>
                    <div className="detailItem">
                      <b>
                        <span className="itemKey">Last Updated At :</span>
                      </b>
                      <span className="itemValue">
                        {Admin ? (
                          moment(Admin?.updatedAt).format("DD/MM/YYYY")
                        ) : (
                          <span className="itemKey2"> </span>
                        )}
                      </span>
                    </div>
                    <div className="detialItem"></div>
                  </>
                ) : (
                  <>
                    <div className="skeleton-placeholder-title" />
                    <div className="skeleton-placeholder-title2" />
                    <div className="skeleton-placeholder-title2" />
                    <div className="skeleton-placeholder" />
                    <div className="skeleton-placeholder" />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageContainer>
  );
};

export default AdminProfile;
